import type { Nullish } from "@ca/types/util";
interface Codeable {
	locId?: string | null;
	icaoId?: string | null;
	iataId?: string | null;
}
export const displayAirportCode = <T extends string | null = string>(
	airport?: Nullish<Codeable>,
	fallback: T = "--" as T,
): string | T => {
	if (airport?.icaoId) {
		return airport.icaoId;
	}
	if (airport?.locId) {
		return airport.locId;
	}
	if (airport?.iataId) {
		return airport.iataId;
	}
	return fallback;
};